import React, { useContext, useEffect, useState } from 'react';
import { Input, Table } from 'reactstrap';
import './Setting.scss';
import { useQuery } from '@tanstack/react-query';
import useAxios from '../../hooks/useAxios';
import FetchStatus from '../../components/fetchStatus/FetchStatus';
import { showToast } from '../../components/toast/Toast';
import { AuthContext } from '../../context/AuthContext';

const roles = [
  { title: 'Karyawan', name: '1024', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Staf', name: '2190', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Supervisor', name: '4219', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Manajer', name: '3402', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Manajer Eksekutif', name: '6011', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Kepala Direktorat', name: '4944', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Direktur Utama', name: '2010', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Sekretaris Perusahaan', name: '5147', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Kepala SPI', name: '7520', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Kepala Manajemen Risiko', name: '4621', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Super Admin', name: '2489', allowedRoles: ['2489'] },
  { title: 'Admin', name: '2131', allowedRoles: ['2489'] },
  { title: 'Admin Absensi', name: '4012', allowedRoles: ['2489', '0129'] },
  { title: 'Admin Penggajian', name: '1201', allowedRoles: ['2489', '0129'] },
  { title: 'Manajer SDM', name: '0129', allowedRoles: ['2489', '2131', '0129'] },
  { title: 'Manajer Keuangan', name: '8513', allowedRoles: ['2489', '2131', '0129'] },
];

const UserRoles = () => {
  const { auth } = useContext(AuthContext);
  const [isUpdating, setIsUpdating] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeCollection, setEmployeeCollection] = useState([]);
  const api = useAxios();

  const { isLoading, error, data, refetch, isFetching } = useQuery({
    queryKey: ['employeesroles'],
    queryFn: () =>
      api.get(`employee/roles`).then((res) => {
        setEmployeeList(res.data.data);
        return res.data.data;
      }),
  });

  useEffect(() => {
    if (data) {
      const employeId = [];

      data.forEach((item) => {
        const employeRoles = [];

        if (item.roles.length > 0) {
          item.roles.forEach((role) => {
            employeRoles.push(role.name);
          });
        }

        employeId.push({
          employe_id: item.employe_id,
          roles: employeRoles,
        });
      });
      setEmployeeCollection(employeId);
    }
  }, [data]);

  const handleChange = async (e, employeId, name) => {
    setIsUpdating(true);
    let dataStore = {};
    employeeCollection.forEach((item) => {
      if (item.employe_id === employeId) {
        if (e.target.checked) {
          item.roles.push(e.target.id);
        } else {
          const index = item.roles.indexOf(e.target.id);
          item.roles.splice(index, 1);
        }

        dataStore = {
          employe_id: item.employe_id,
          roles: item.roles,
        };
      }
    });

    await api
      .post('sync-role', dataStore)
      .then(() => {
        refetch();
        showToast(
          `${e.target.checked ? 'Menambahkan' : 'Menghapus'} Role ${e.target.name} untuk ${name}`,
          'success',
        );
      })
      .catch((err) => {
        setTimeout(() => {
          refetch();
        }, 5000);
        showToast(`Gagal update role karyawan. ${err.response.data.message}`, 'error');
      });

    setIsUpdating(false);
  };

  const handleSearch = (val) => {
    if (val) {
      const filteredData = employeeList?.filter((item) =>
        item?.first_name?.toLowerCase().includes(val.toLowerCase()),
      );
      setEmployeeList(filteredData);
    } else {
      setEmployeeList(data);
    }
  };

  return (
    <>
      <div className="right-header">
        <h4>Pengaturan Hak Akses Karyawan</h4>
        <span>Mengatur hak akses karyawan sesuai dengan jabatan dan role yang diinginkan</span>
      </div>
      <div className="right-body">
        <div className="d-flex justify-content-between mb-2">
          <div>
            <Input
              type="search"
              placeholder="Cari Karyawan ..."
              size="sm"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
        {isLoading ? (
          <FetchStatus type="loading" />
        ) : error ? (
          <FetchStatus type="error" />
        ) : (
          <div style={{ maxHeight: '65vh', overflow: 'auto' }}>
            <Table hover style={{ position: 'relative' }} bordered>
              <thead>
                <tr>
                  <th
                    rowSpan="2"
                    style={{
                      verticalAlign: 'middle',
                      position: 'sticky',
                      top: 0,
                      left: 0,
                      zIndex: isUpdating ? 2 : 1,
                      backgroundColor: '#f8f9fa',
                      minWidth: '200px',
                    }}
                  >
                    Nama Karyawan
                  </th>
                  <th
                    colSpan={roles.length}
                    style={{
                      verticalAlign: 'middle',
                      position: 'sticky',
                      top: 0,
                      textAlign: 'center',
                    }}
                  >
                    Role User
                  </th>
                </tr>
                <tr>
                  {roles.map((role) =>
                    role.allowedRoles.find((allowedRole) => auth?.roles?.includes(allowedRole)) ? (
                      <th
                        key={role.name}
                        style={{
                          textAlign: 'center',
                          position: 'sticky',
                          top: 0,
                          zIndex: isUpdating ? 1 : 0,
                          verticalAlign: 'middle',
                          minWidth: '160px',
                        }}
                      >
                        {role.title}
                      </th>
                    ) : null,
                  )}
                </tr>
              </thead>
              <tbody>
                {employeeList?.map((emp) => (
                  <tr key={emp.employe_id}>
                    <td
                      className="fw-bold"
                      style={{ position: 'sticky', left: 0, backgroundColor: '#f8f9fa' }}
                    >{`${emp.first_name} ${emp.last_name || ''}`}</td>
                    {roles.map((role) =>
                      role.allowedRoles.find((allowedRole) =>
                        auth?.roles?.includes(allowedRole),
                      ) ? (
                        <td key={emp.employe_id + role.name} style={{ textAlign: 'center' }}>
                          {isFetching ? (
                            <span>...</span>
                          ) : (
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={role.name}
                              name={role.title}
                              defaultChecked={emp.roles.map((r) => r.name).includes(role.name)}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  emp.employe_id,
                                  `${emp.first_name} ${emp.last_name || ''}`,
                                )
                              }
                              disabled={isUpdating}
                            />
                          )}
                        </td>
                      ) : null,
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </>
  );
};

export default UserRoles;
